module.exports = __webpack_public_path__ + "images/c2cfb5fee9909830037e6bd3873b1c58.png";